import { render, staticRenderFns } from "./MaterialWeightSummary.vue?vue&type=template&id=859feeae&scoped=true&"
import script from "./MaterialWeightSummary.vue?vue&type=script&lang=js&"
export * from "./MaterialWeightSummary.vue?vue&type=script&lang=js&"
import style0 from "./MaterialWeightSummary.vue?vue&type=style&index=0&id=859feeae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859feeae",
  null
  
)

export default component.exports